import type { FragmentType } from '@packages/gql/generated/shopping';
import type { CustomerReviewResponseFragmentFragmentDoc } from '@packages/gql/generated/shopping/CustomerReviewResponseFragmentFragmentDoc';
import { unmask } from '@packages/gql/src/betterMasking';

/* GraphQL */ `
  fragment CustomerReviewResponseFragment on Response {
    title
    description
  }
`;

export type CustomerReviewResponseProps = {
  /**
   * data - the data needed to render the component
   */
  data: FragmentType<typeof CustomerReviewResponseFragmentFragmentDoc>;
  /**
   * label - the label that is placed beneath the avatar icon
   */
  label: string;
};

/**
 * The CustomerReviewResponse component displays the a response from the customer service to the review
 */
export const CustomerReviewResponse = ({ data, label }: CustomerReviewResponseProps) => {
  const { title, description } = unmask<typeof CustomerReviewResponseFragmentFragmentDoc>(data);

  return (
    <div className="border-color-grey rounded border p-1.5">
      <div className="flex flex-row items-center gap-1">
        <span className="bg-color-grey-light box-content inline-block h-3 w-3 rounded-full p-[3px]">
          <span className="icon-emp-service-consulting inline-block h-full w-full" />
        </span>
        <div className="text-size-body2 font-bold">{label}</div>
      </div>
      <div className="text-size-body2 mt-1">
        {title.length ? <div className="font-semibold">{title}</div> : null}
        <div>{description}</div>
      </div>
    </div>
  );
};
